export const SOURCE_PLACEHOLDER = 'lynka, xdconnects, headwear, midocean, pfconcept'

